import React from "react";
import { Link } from "react-router-dom";

import blog1 from "../img/blog-1.png";
import blog2 from "../img/blog-2.png";

// import "./style.css";

const BlogSection = () => {
  return (
    <section className="latest-news-area" data-aos="fade-up">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="site-heading">
              <h3 className="sub-title">LATEST BLOGS</h3>
              <h2 className="section-title">Thoughts on Things</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Link to="/blog-single1" className="news-box news-box-margin">
              <div className="news-img">
                <img src={blog1} alt="img" />
              </div>
              <div className="news-text">
                <h3>The Pros and Cons of Buying New Construction vs. Existing Homes</h3>
              </div>
            </Link>
          </div>
          <div className="col-md-6">
            <Link to="/blog-single2" className="news-box">
              <div className="news-img">
                <img src={blog2} alt="img" />
              </div>
              <div className="news-text">
                <h3>The Impact of Location on Commercial Property Value</h3>
              </div>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center news_more">
              <Link to="/blog" className="cta-btn btn-fill">
                Explore More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
